import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'

const FormBase = styled.form`
  display: inline;
`

const LinkButton = styled.button`
  cursor: pointer;
  display: inline;
  border: 0;
  background-color: transparent;
  color: var(--color-primary);
  text-transform: uppercase;
  padding: 0;
  margin: 0;
  text-decoration: none;
  font-weight: var(--font-weight-bold);
`

const DEFAULT_COUNTDOWN = 300

function OtpResendForm(props) {
  const {
    handleSubmit,
    isSubmitting,
    method,
    action,
    initialCountdown,
    // values,
    setFieldValue,
    smsMode,
    loginResend,
  } = props
  const [countdown, setCountdown] = React.useState(
    typeof initialCountdown !== 'undefined'
      ? initialCountdown
      : DEFAULT_COUNTDOWN,
  )

  const tick = () => {
    if (countdown === 0) {
      return
    }

    setCountdown(countdown - 1)
  }

  React.useEffect(() => {
    const timerID = setInterval(() => tick(), 1000)

    return () => {
      clearInterval(timerID)
    }
  })

  const resendOtp = e => {
    e.preventDefault()

    setCountdown(DEFAULT_COUNTDOWN)
    handleSubmit(e)
  }

  return (
    <FormBase onSubmit={resendOtp} method={method} action={action}>
      Did not receive code?{' '}
      {countdown ? (
        `Resend in ${countdown} sec`
      ) : (
        <>
          <LinkButton
            disabled={isSubmitting}
            type="submit"
            onClick={() => setFieldValue('toMobile', smsMode)}
          >
            Resend
          </LinkButton>
          {loginResend && (
            <>
              {' or '}
              <LinkButton
                disabled={isSubmitting}
                type="submit"
                onClick={() => setFieldValue('toMobile', !smsMode)}
              >
                Resend via {smsMode ? 'email' : 'SMS'}
              </LinkButton>
            </>
          )}
        </>
      )}
    </FormBase>
  )
}

OtpResendForm.defaultProps = {
  handleSubmit: null,
  isSubmitting: false,
  method: 'get',
  action: '',
}

OtpResendForm.propTypes = {
  handleSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
  method: PropTypes.oneOf(['get', 'post']),
  action: PropTypes.string,
}

export default OtpResendForm
